import { NAME } from './constants';
import * as m from './model';

export const model = (state) => state[NAME] || m.initialState;

// We default to the control variant i.e. '0' if for any reason fetching the variant/control failed, as indicated by it not being in the store
export const getExperimentVariant = (state, experimentId) =>
  model(state).experiments?.[experimentId] || '0';
